import { SuccessResponse } from './common';

export enum AgeVerificationStatus {
  Required = 'REQUIRED',
  InProgress = 'IN_PROGRESS',
  Verified = 'VERIFIED',
  Rejected = 'REJECTED',
  Failed = 'FAILED',
}

export enum AgeVerificationType {
  AgeEstimation = 'AGE_ESTIMATION',
  IdVerification = 'ID_VERIFICATION',
}

export type LivenessRetrySuggestion =
  | 'SHOW_CAMERA_FEED_ISSUE_SCREEN_IF_REJECTED'
  | 'SHOW_STANDARD_RETRY_SCREEN_IF_REJECTED';

export type DTOAgeVerificationStatusResponse = SuccessResponse<{
  status: AgeVerificationStatus;
  /**
   * 인증 방식 구분. 값이 없으면(구버전 서버 응답 또는 Yoti 이외 벤더) AGE_ESTIMATION으로 간주한다.
   */
  type?: AgeVerificationType;
  livenessRetrySuggestion?: LivenessRetrySuggestion;
}>;
